import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, OrgaoAdesaoAudesp } from 'eddydata-lib';

@Injectable({
    providedIn: 'root'
})
export class OrgaoAdesaoAudespService extends BaseResourceService<OrgaoAdesaoAudesp> {

    constructor(
        protected injector: Injector
    ) {
        super(`orgao-adesao-audesps`, injector);
    }

}
